
import {IonContent, IonPage, IonGrid, IonRow, IonCol} from '@ionic/vue';

export default {
  name: 'Datenschutz',
  components: {
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonPage
  },
  mounted(this: { $refs: { scriptHolder: HTMLDivElement } }) {
    const scriptEl = document.createElement('script');
    scriptEl.setAttribute('src', 'https://consent.cookiebot.com/4e397f2b-deb1-4352-a333-13693774b0d8/cd.js');
    scriptEl.setAttribute('id', 'CookieDeclaration');
    scriptEl.setAttribute('type', 'text/javascript');
    (this.$refs.scriptHolder as HTMLDivElement).appendChild(scriptEl);
  },
}

